module.exports = __webpack_public_path__ + "img/e5275f7.png";